import styled from 'styled-components';

export const CloseButton = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
`;
